import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/:userId',
      name: 'Home',
      component: Home,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js